import { render, staticRenderFns } from "./FoodMenuSidebar.vue?vue&type=template&id=9db8ff32&scoped=true&"
import script from "./FoodMenuSidebar.vue?vue&type=script&lang=js&"
export * from "./FoodMenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FoodMenuSidebar.vue?vue&type=style&index=0&id=9db8ff32&lang=scss&scoped=true&"
import style1 from "./FoodMenuSidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db8ff32",
  null
  
)

export default component.exports